<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title' style='padding: 10px;'>
        Pagamento
      </div>

      <button mat-button (click)='goBack()'>
        <mat-icon>arrow_back</mat-icon>
      </button>

    </mat-toolbar>

  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='primary' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <div style="width: 500px; margin: auto">

    <mat-card>

      <div class='congress-label'>
        {{currentOrderd.product_name}}
      </div>

      <div class='order-line'>
        <div class='order-label'>
          Nome:
        </div>
        <div class='order-field'>
          {{currentOrderd.member_name}}
        </div>
      </div>

      <div class='order-line'>
        <div class='order-label'>
          Email:
        </div>
        <div class='order-field'>
          {{currentOrderd.member_email}}
        </div>
      </div>

      <div class='order-line'>
        <div class='order-label'>
          CPF/Doc:
        </div>
        <div class='order-field'>
          {{currentOrderd.member_cpf}}
        </div>
      </div>

      <div class='order-line'>
        <div class='order-label'>
          Categoria:
        </div>
        <div class='order-field'>
          {{currentOrderd.category_name}}
        </div>
      </div>

     </mat-card>


     <mat-card>

      <div class='order-line' *ngIf="!currentOrderd.payAsOverdue">
        <div class='order-label'>
          Anuidades:
        </div>
        <div class='order-field-value'>
          R$ {{currentOrderd.member_debit | currency:'BRL':'':'1.2-2'}}
        </div>
      </div>

      <div class='order-line'>
        <div class='order-label'>
          Inscrição:
        </div>
        <div class='order-field-value'>
          R$ {{currentOrderd.value | currency:'BRL':'':'1.2-2'}}
        </div>
      </div>

      <div class='order-line'>
        <div class='order-label'>
          Total:
        </div>
        <div class='order-field-value'>
          <b>R$ {{currentOrderd.total | currency:'BRL':'':'1.2-2'}}</b>
        </div>
      </div>

      <!--
    <div class='order-line'>
      <div class='order-label'>
        Total USD$:
      </div>
      <div class='order-field-value'>
        {{ usd_value | currency:'BRL':'':'1.2-2'}}
      </div>
    </div>
    -->

    </mat-card>

    <mat-card>

      <form [formGroup]="orderForm">

        <div style="height: 40px; margin-bottom: 20px;">
          <mat-form-field class="tid-width" appearance="outline">
            <mat-label>Comprovante pagamento</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="orderForm.controls.tid"
              autocomplete="off">
            <mat-error *ngIf="orderForm.controls.tid.hasError('required')">
              O número do comprovante é obrigatório
            </mat-error>
          </mat-form-field>
        </div>

      </form>

      <button mat-raised-button (click)='updateOrder()' class="order-button" [disabled]="orderForm.invalid">
        Registrar
      </button>

    </mat-card>

  </div>

</div>